import axios, {} from "axios";
const DOCTOR_URL = "api/v4/consultation/doctors/";
const REGION_URL = "api/v4/region";
const RETRIES = 2;
const RETRY_DELAY_MS = 800;
function getDoctorId() {
    var _a;
    return (_a = new URLSearchParams(location.search).get("doctor_id")) !== null && _a !== void 0 ? _a : "";
}
function getBaseURL() {
    const hostname = window.location.hostname;
    if (hostname.startsWith(__RU_SITE_PREFIX__)) {
        const url = new URL(__API__);
        url.hostname = __RU_SITE_PREFIX__ + url.hostname;
        return url.toString();
    }
    return __API__;
}
const instance = axios.create({
    baseURL: getBaseURL(),
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    },
});
// A response below 500 means the backend reached a decision about this doctor
// and will reach the same one again, so the card is unrenderable and someone
// has to go and fix it. Only a request that never got an answer, or got a 5xx,
// says nothing about the doctor — anything thrown after the response arrived
// belongs to the first case however it looks.
function isTransientFailure(error) {
    return (axios.isAxiosError(error) &&
        (error.response === undefined || error.response.status >= 500));
}
// A timed-out request has already spent 30 seconds of the patient's attention;
// spending it again before anything reaches the screen is worse than showing
// the retry button and letting them decide.
function isWorthRetrying(error) {
    return isTransientFailure(error) && error.code !== "ECONNABORTED";
}
function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
// The tunnel this is served through comes up cold: the first call after an idle
// spell can 503 and the next one succeed. It takes both endpoints down at once,
// so both go through here, and the patient sees neither the outage screen nor a
// foreign dial prefix over something that heals in under a second.
async function withRetry(request) {
    for (let attempt = 0;; attempt++) {
        try {
            return await request();
        }
        catch (error) {
            if (attempt === RETRIES || !isWorthRetrying(error)) {
                throw error;
            }
            await delay(RETRY_DELAY_MS);
        }
    }
}
function getDoctor(lang) {
    return withRetry(async () => {
        const response = await instance.get(DOCTOR_URL + getDoctorId(), {
            params: { lang, format: "html", skip_tariff_check: 1 },
        });
        const { fullName, src } = response.data.data;
        return { fullName, avatar: src };
    });
}
// Dial prefix of the country the patient is calling from, or null whenever the
// geo lookup produced nothing — the caller supplies its own fallback.
function getPhonePrefix() {
    return withRetry(async () => {
        const response = await instance.get(REGION_URL);
        return (response.data && response.data.phonePrefix) || null;
    });
}
export default {
    getDoctor,
    getDoctorId,
    getPhonePrefix,
    isTransientFailure,
};
